import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ background: "#fff" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Comprehensive Suite of <span>Web3 Game Development Services</span>{" "}
              at TekRevol
            </h2>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Discuss Your Project
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Full-cycle Web3Game Development</h4>
                  <p>
                    We provide complete Web3 game development services starting
                    from game ideation, storyline and mechanics, UI/UX design
                    and game art creation, frontend, backend development, API
                    integration, wallet and smart contracts execution, habit
                    loops development, testing, quality assurance, launch,
                    post-launch maintenance, ongoing support and development and
                    user acquisition.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Web3 Asset Creation</h4>
                  <p>
                    Web3 games significantly depend on Blockchain-based assets.
                    These assets include cryptocurrencies, NFTs, and tokens. We
                    design, develop and deploy these digital assets to be
                    further utilized in the game’s technical/functional
                    architecture. We have a dedicated Blockchain development
                    team laser-focused on building digital art and 3D models,
                    NFT metadata and tokens that players own, trade and use
                    within the game.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Wallet Integration</h4>
                  <p>
                    For simplest Blockchain and Web3 games, players need to own,
                    transfer, trade, and use digital assets – and to work around
                    these digital assets, NFT and crypto games need digital
                    wallets. TekRevol also builds APIs to connect these wallets
                    so players can perform transactions or simply manage their
                    digital assets directly from their game interface. Key
                    deliverables are wallet integration features and security
                    certificates.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Web3 Game Design</h4>
                  <p>
                    With Web3 game development solutions, TekRevol also offers
                    independent game UI/UX, storyline and art direction. We
                    define gameplay mechanics, user interfaces, Blockchain
                    integration execution. Key deliverables in our Web3 game
                    design services include a comprehensive Game Design Document
                    with wireframes and feature mockups, prototypes and
                    Blockchain integration plan.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Web3 Game Code Review and Testing</h4>
                  <p>
                    We examine the game’s code for errors, vulnerabilities,
                    security issues and programming glitches. If you already
                    have a Web3 functional, or ready to go-live, our testing and
                    quality assurance teams can verify the security and
                    performance standards to make help you launch a 100%
                    experience-first game. Key deliverables in code review
                    include test plans, test cases and review reports and
                    security audits.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Smart Contracts Development</h4>
                  <p>
                    We write and deploy smart contracts to automate game
                    functionalities, player features and wallet transactions.
                    These contracts are self-executing programs stored on the
                    Blockchain – efficient, reliable and free of
                    vulnerabilities. Our Web3 game developers build these smart
                    contracts with the primary goal to facilitate decentralized
                    interactions. As a game founder, you get access to a smart
                    contract code and deployment scripts.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
